const DAY = 86400000;

const startOfToday = () => { const d = new Date(); d.setHours(0, 0, 0, 0); return d; };

// Three escalating tiers: notice ≤30 days, warning ≤7 days, urgent ≤1 day or expired.
export function licenseTier(expiry) {
  if (!expiry) return null;
  const [y, m, d] = expiry.split("-").map(Number);
  const days = Math.round((new Date(y, m - 1, d) - startOfToday()) / DAY);
  if (days > 30) return null;
  const tier = days <= 1 ? "urgent" : days <= 7 ? "warning" : "notice";
  const label = days < 0 ? `License expired ${-days} day${days === -1 ? "" : "s"} ago`
    : days === 0 ? "License expires today" : days === 1 ? "License expires tomorrow" : `License expires in ${days} days`;
  return { tier, days, label };
}

export const TIER_STYLES = {
  urgent: "bg-rose-50 text-rose-800 border-rose-300",
  warning: "bg-orange-50 text-orange-800 border-orange-300",
  notice: "bg-yellow-50 text-yellow-800 border-yellow-300",
};

export function licenseSummary(drivers) {
  const out = { urgent: 0, warning: 0, notice: 0 };
  (drivers || []).filter((d) => d.status !== "archived").forEach((d) => {
    const t = licenseTier(d.license_expiry);
    if (t) out[t.tier] += 1;
  });
  return out;
}
